.toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.title {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.05rem;
  min-width: 180px;
  text-align: center;
}

.weekdayRow {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 1px;
  background: light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4));
  border: 1px solid light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4));
  border-bottom: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
}

.weekday {
  background: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6));
  padding: 8px 10px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-2));
  text-align: left;
}

.grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 1px;
  background: light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4));
  border: 1px solid light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4));
  border-top: 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow: hidden;
}

.cell {
  background: light-dark(#ffffff, var(--mantine-color-dark-7));
  min-height: 110px;
  padding: 6px 6px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  transition: background 120ms;
}

.cell:hover {
  background: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6));
}

.cellMuted {
  background: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-8));
}

.cellMuted:hover {
  background: light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-7));
}

.cellToday {
  background: light-dark(var(--mantine-color-laut-0), rgba(14, 124, 123, 0.12));
}

.cellToday:hover {
  background: light-dark(var(--mantine-color-laut-1), rgba(14, 124, 123, 0.18));
}

.dayNumber {
  font-size: 0.75rem;
  font-weight: 500;
  color: light-dark(var(--mantine-color-gray-7), var(--mantine-color-dark-1));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  align-self: flex-start;
}

.dayNumberMuted {
  color: light-dark(var(--mantine-color-gray-4), var(--mantine-color-dark-3));
}

.dayNumberToday {
  background: var(--mantine-color-laut-6);
  color: white;
  font-weight: 600;
}

.chip {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px 2px 8px;
  font-size: 0.72rem;
  line-height: 1.2;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  background: light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-5));
  color: light-dark(var(--mantine-color-gray-8), var(--mantine-color-dark-0));
  border-left: 3px solid var(--mantine-color-gray-5);
  transition:
    filter 120ms,
    transform 120ms;
}

.chip:hover {
  filter: brightness(0.95);
  transform: translateX(1px);
}

.chipText {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chipDone {
  text-decoration: line-through;
  opacity: 0.55;
}

.chipUrgent {
  background: light-dark(var(--mantine-color-red-0), rgba(220, 50, 50, 0.18));
  border-left-color: var(--mantine-color-red-6);
  color: light-dark(var(--mantine-color-red-9), var(--mantine-color-red-2));
}

.chipHigh {
  background: light-dark(var(--mantine-color-orange-0), rgba(220, 130, 40, 0.18));
  border-left-color: var(--mantine-color-orange-6);
  color: light-dark(var(--mantine-color-orange-9), var(--mantine-color-orange-2));
}

.chipMedium {
  background: light-dark(var(--mantine-color-laut-0), rgba(14, 124, 123, 0.18));
  border-left-color: var(--mantine-color-laut-6);
  color: light-dark(var(--mantine-color-laut-9), var(--mantine-color-laut-2));
}

.chipLow {
  background: light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-5));
  border-left-color: var(--mantine-color-gray-5);
}

.more {
  font-size: 0.7rem;
  color: light-dark(var(--mantine-color-laut-7), var(--mantine-color-laut-3));
  cursor: pointer;
  padding: 1px 6px;
  align-self: flex-start;
  font-weight: 500;
}

.more:hover {
  text-decoration: underline;
}

.legend {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 0.7rem;
  color: light-dark(var(--mantine-color-gray-6), var(--mantine-color-dark-2));
}

.legendItem {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.legendDot {
  width: 8px;
  height: 8px;
  border-radius: 2px;
}

@media (max-width: 768px) {
  .cell {
    min-height: 78px;
    padding: 4px;
  }
  .weekday {
    padding: 6px 4px;
    font-size: 0.62rem;
  }
  .chip {
    font-size: 0.65rem;
    padding: 1px 4px 1px 6px;
  }
  .dayNumber {
    width: 18px;
    height: 18px;
    font-size: 0.7rem;
  }
}
